export const {
  VITE_APP_FB_APP_ID: FB_APP_ID,
  VITE_APP_GOOGLE_CLIENT_ID: GOOGLE_CLIENT_ID,
  VITE_APP_XSOLLA_URL: XSOLLA_URL,
  VITE_APP_REDIRECT_URI: APP_REDIRECT_URL,
  VITE_APP_REDIRECT_URI_LOGOUT: APP_REDIRECT_URL_LOGOUT,
  VITE_APP_SCOPELY_ID_AUTH_URL: SCOPELY_ID_AUTH_URL,
  VITE_APP_TITAN_API_KEY: TITAN_API_KEY,
  VITE_APP_SESSIONTOKEN_EXPIRE_TIME_MINUTE: SESSIONTOKEN_EXPIRE_TIME_MINUTE,
  VITE_APP_SCOPELY_ID_CLIENT_ID: SCOPELY_ID_CLIENT_ID,
  VITE_APP_SCOPELY_ID_PROVIDER_URL: SCOPELY_ID_PROVIDER_URL,
  VITE_APP_XSOLLA_PAYMENT_URL: XSOLLA_PAYMENT_URL,
  VITE_APP_XSOLLA_APIKEY: XSOLLA_APIKEY,
  VITE_APP_XSOLLA_PUBLISHER_ID: XSOLLA_PUBLISHER_ID,
  VITE_APP_XSOLLA_PROJECTID: XSOLLA_PROJECTID,
  VITE_APP_TEMP_SESSIONTOKEN: TEMP_SESSIONTOKEN,
  VITE_APP_PUSH_VAPID_KEY: PUSH_VAPID_KEY,
} = import.meta.env;
